/**
 * The pages of the web app the agent sends links to (prompts.ts appLinksBlock, the computer_task result), and the deep
 * link of the computer page that opens the cloud computer's live screen at once (client routes/computer.tsx).
 */

/** `/ordinateur?ecran=direct`: the computer page, its live screen opened (or the start button when it is off). */
export const LIVE_VIEW_SEARCH = { ecran: "direct" } as const;
export const LIVE_VIEW_PATH = `/ordinateur?ecran=${LIVE_VIEW_SEARCH.ecran}`;

/** Every page the agent may name, in the order the context lists them (French labels: the app is in French). */
export const APP_PAGES: readonly { path: string; label: string }[] = [
  { path: "/", label: "Pulse, l'accueil (brief du jour, validations et missions en cours)" },
  { path: "/discussion", label: "Discussion (la conversation avec toi)" },
  { path: "/approbations", label: "Validations en attente" },
  { path: "/missions", label: "Missions et tâches (résultats, questions)" },
  { path: "/ordinateur", label: "Ordinateur (ton ordinateur cloud : allumer, arrêter, taille ; ses ordinateurs reliés)" },
  { path: LIVE_VIEW_PATH, label: "Écran en direct de ton ordinateur cloud" },
  { path: "/memoire", label: "Mémoire (ce que tu sais de lui)" },
  { path: "/coffre", label: "Coffre (ses mots de passe, cartes, adresses et IBAN, chiffrés : ajouter, importer un export CSV, voir l'utilisation, révéler après vérification, supprimer)" },
  { path: "/connexions", label: "Connexions (Gmail, Agenda, Slack…, iMessage, Telegram, e-mail)" },
  { path: "/reglages", label: "Réglages (brief, horaires, heures calmes, pause, autonomie, langue, ton prénom)" },
  { path: "/activite", label: "Activité (ce que tu as fait, coûts)" },
];

/** The sign-in page: phone number (the code arrives by iMessage) or e-mail address. */
export const LOGIN_PATH = "/connexion";
